import { ArticleCardStyleProps } from "@config/articleCard";

export const HORIZONTAL_PACKAGE_CARD_STYLE: ArticleCardStyleProps = {
  cardWrapper:
    "flex flex-col items-center justify-center basis-[17%] break-words overflow-auto",
  headerWrapper: "block w-full",
  contentWrapper: "w-full",
  dateStyle: "text-xxs text-black-700",
  sectionNameWrapper: "flex flex-col items-start gap-2",
  sectionNameStyle: "text-[12px] lg:text-[12px] font-semibold",
  dateTitleWrapper: "flex flex-col-reverse gap-sm mt-xs",
  titleStyle:
    "lg:text-sm font-medium font-secondary text-black-800 leading-[19.2px]",
  titleHoverStyle: "hover:text-blue-400",
};

export const VERTICAL_PACKAGE_CARD_STYLE_FIRST = {
  cardWrapper: "flex flex-col lg:flex-row justify-center w-full gap-md",
  hero: "mb-0",
  headerWrapper: "basis-3/5 block w-full",
  contentWrapper: "basis-2/5 w-full mb-0",
  dateStyle: "text-black-700 font-semimedium leading-[21px]",
  dateTitleWrapper: "flex flex-col-reverse justify-between flex-grow gap-sm",
  titleStyle:
    "lg:text-[20px] font-medium font-secondary text-black-800 leading-[30px]",
  titleHoverStyle: "hover:text-blue-400",
  sectionNameStyle: "text-[12px] lg:text-xxs font-semibold",
};

export const VERTICAL_PACKAGE_CARD_STYLE_REST = {
  cardWrapper: "flex justify-center w-full gap-xs",
  hero: "mb-xs",
  headerWrapper: "basis-3/10 md:basis-2/5 lg:basis-3/10 block w-full",
  contentWrapper: "basis-7/10 md:basis-3/5 lg:basis-7/10 w-full mb-0 gap-0",
  dateStyle: "text-black-700 font-semimedium leading-[21px]",
  dateTitleWrapper: "flex flex-col-reverse gap-xs",
  titleStyle:
    "lg:text-sm font-medium font-secondary text-black-800 leading-[19.2px]",
  titleHoverStyle: "hover:text-blue-400",
  sectionNameStyle: "text-[12px] lg:text-[12px] font-semibold",
  sectionNameWrapper: "justify-between",
};
